/* 
Model defined for Maintaining Permission Responses. It can also be used for transferring model
*/
export class PermissionModel {
    description: string;
    groupName: string;
    id: string;
    name: string;
    partnerId: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/role/PermissionModel.ts